import React from 'react';
import styled from 'styled-components';
import { Fade, Zoom } from "react-awesome-reveal";
import ceo from '../Images/ceo.jpg'
import s1 from '../Images/s1.jpg'
import s2 from '../Images/s2.jpg'
import s3 from '../Images/s3.jpg'
import { useNavigate } from 'react-router-dom';

// --- Styled Components ---

const TeamSection = styled.section`
  width: 100%;
  padding: 10px 0;
  background-color: #fcfcfc;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const Container = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 1.8rem;
  color: #439E6D;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 10px;
`;

const LeadMemberWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
`;

const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); // Adjusted for the 3 smaller images
  gap: 10px;
  // margin-bottom: 40px;

  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ImageBox = styled.div`
  width: ${props => props.isLead ? '350px' : '50%'};
  aspect-ratio: 1 / 1;
  overflow: hidden;
  margin-bottom: 15px;
  border: 1px solid #eee;
  border-radius:50%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: grayscale(20%); // Matches the corporate look
    transition: filter 0.3s ease;
  }

  &:hover img {
    filter: grayscale(0%);
  }
`;

const Name = styled.h4`
  font-size: 1.1rem;
  font-weight: 700;
  color: #439E6D;
  margin: 10px 0 5px 0;
  text-transform: uppercase;
`;

const Role = styled.p`
  font-size: 0.85rem;
  color: #666;
  margin: 0;
`;

const Quote = styled.p`
  font-size: 1rem;
  font-weight: 600;
  color: #1a2b49;
  margin: 20px 0 20px 0;
`;

const ContactBtn = styled.button`
  background-color: #439E6D; // The gray button color from your image
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background-color: #5a6268;
  }
`;

// --- Data ---

const team = {
  leader: {
    name: "ENGR/SURV. PATRICK CHIGERE fnis, mnis",
    role: "MD/CEO",
    img: ceo
  },
  members: [
    { name: "SURV. EZINYIKBA CHUKWUMA", role: "Senior Surveyor", img: s1 },
    { name: "NANCYMIRRIAN EZE", role: "Secretary", img: s2 },
    { name: "CHINONSO UGORJI", role: "HSE Coordinator", img: s3 }
  ]
};

// --- Component ---

const CorporateTeam = () => {
    const navigate = useNavigate();
  return (
    <TeamSection>
      <Container>
        <Fade triggerOnce>
          <Title>Our Corporate Office Team</Title>
        </Fade>

        {/* Lead Image (Centered) */}
        <LeadMemberWrapper>
          <Zoom triggerOnce>
            <Card>
              <ImageBox isLead>
                <img src={team.leader.img} alt={team.leader.name} />
              </ImageBox>
              <Name>{team.leader.name}</Name>
              <Role>{team.leader.role}</Role>
            </Card>
          </Zoom>
        </LeadMemberWrapper>

        {/* Other Members Grid */}
        <TeamGrid>
          <Fade cascade damping={0.1} triggerOnce direction="up">
            {team.members.map((m, i) => (
              <Card key={i}>
                <ImageBox>
                  <img src={m.img} alt={m.name} />
                </ImageBox>
                <Name>{m.name}</Name>
                <Role>{m.role}</Role>
              </Card>
            ))}
          </Fade>
        </TeamGrid>

        <Fade triggerOnce delay={400}>
          <Quote>We advise global leaders on their most critical issues and opportunities.</Quote>
          <ContactBtn onClick={()=>navigate('/contactus')}>Contact Us Today</ContactBtn>
        </Fade>
      </Container>
    </TeamSection>
  );
};

export default CorporateTeam;